import type { OrderByDto, OrderByMapDto } from "@core/data/dto/order.dto.ts";
import { OrderDirectionEnumDto } from "@core/data/dto/order.dto.ts";
import type { Order } from "@core/domain/models/order.model.ts";
import { OrderDirection } from "@core/domain/models/order.model.ts";
import type { Undefinable } from "@core/domain/types/undefinable.type.ts";
import { injectable } from "inversify";

@injectable()
export class OrderMapper {
    mapToDto<Model extends object, Dto extends object>(
        order: Undefinable<Order<Model>>,
        orderByMap: OrderByMapDto<Model, Dto>,
    ): OrderByDto<Dto> {
        if (!order) {
            return undefined;
        }

        if (!order.direction) return undefined;

        const mappedField = orderByMap[order.field];
        if (mappedField === null) return undefined;

        const mappedDirection =
            order.direction === OrderDirection.Asc
                ? OrderDirectionEnumDto.Asc
                : OrderDirectionEnumDto.Desc;

        return `${mappedField} ${mappedDirection}`;
    }
}
